(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileBackdrop = document.querySelector('[data-mobile-nav-backdrop]');
  var openBtns = document.querySelectorAll('[data-mobile-menu-open]');
  var closeBtns = document.querySelectorAll('[data-mobile-menu-close]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  openBtns.forEach(function (btn) { btn.addEventListener('click', openMobileNav); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeMobileNav); });
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileNav();
  });

  /* ---------- Mega menu (desktop) ---------- */
  var megaMenuItems = document.querySelectorAll('[data-mega-menu-item]');
  megaMenuItems.forEach(function (item) {
    var toggle = item.querySelector('[data-mega-menu-toggle]');
    if (!toggle) return;

    function open() {
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (item.classList.contains('is-open')) close(); else open();
    });
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
  document.addEventListener('click', function () {
    megaMenuItems.forEach(function (item) {
      item.classList.remove('is-open');
      var toggle = item.querySelector('[data-mega-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- Quantity steppers (product form + cart lines) ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-quantity-minus]');
    var plus = e.target.closest('[data-quantity-plus]');
    if (!minus && !plus) return;

    var wrapper = (minus || plus).closest('.quantity-input');
    var input = wrapper && wrapper.querySelector('[data-quantity-field], .quantity-input__field');
    if (!input) return;

    var current = parseInt(input.value, 10) || 0;
    var next = minus ? Math.max(0, current - 1) : current + 1;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Collection filters: close mobile panel on outside interaction ---------- */
  var filtersToggle = document.querySelector('[data-filters-toggle]');
  if (filtersToggle) {
    document.addEventListener('click', function (e) {
      if (!filtersToggle.contains(e.target) && filtersToggle.hasAttribute('open')) {
        // allow native <details> handling; no forced close needed
      }
    });
  }
})();
